//
// Copyright 2025 DXOS.org
//
/**
 * Space archive is a way to export and import spaces.
 *
 * ## Structure
 *
 * A tar archive with files:
 *  - metadata.json -- JSON-encoded {@link SpaceArchiveMetadata} file.
 *  - documents/
 *    - <document-id>.bin -- Automerge document.
 *  - feeds/
 *    - <feed-id>/
 *      - metadata.json -- JSON-encoded {@link FeedArchiveMetadata} file.
 *      - blocks-0.json -- JSON array of {@link FeedArchiveBlock} (chunks of 100).
 *      - blocks-1.json -- ...
 */
/**
 * Space archive version.
 * Used to track changes to the archive format.
 */
export var SpaceArchiveVersion;
(function (SpaceArchiveVersion) {
    SpaceArchiveVersion[SpaceArchiveVersion["V1"] = 1] = "V1";
})(SpaceArchiveVersion || (SpaceArchiveVersion = {}));
/**
 * Number of blocks per chunk file.
 */
export const FEED_ARCHIVE_BLOCKS_PER_CHUNK = 100;
export const SpaceArchiveFileStructure = {
    metadata: 'metadata.json',
    documents: 'documents',
    feeds: 'feeds',
    feedMetadata: 'metadata.json',
    feedBlocksPrefix: 'blocks-',
};
//# sourceMappingURL=space-archive.js.map